module.exports = __webpack_public_path__ + "img/bild5_test.cc9ea2e3.png";